import React, { useState, useEffect } from "react";
import "./QuizQuestion.css"; // Styling for question layout

function QuizQuestion({ index, question, onAnswer, currentAnswer, handleBack }) {
  const [selectedOption, setSelectedOption] = useState(currentAnswer || "");

  // Reset selected option when question changes
  useEffect(() => {
    setSelectedOption(currentAnswer || "");
  }, [question.id, currentAnswer]);

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleSubmit = () => {
    if (selectedOption) {
      onAnswer(question.id, selectedOption);
    } else {
      alert("Please select an option to continue!");
    }
  };

  const renderInput = () => {
    switch (question.type) {
      case "text":
        return <input type="text" value={selectedOption} onChange={(e) => handleOptionChange(e.target.value)} className="text-input" placeholder="Type your answer here..." />;
      case "radio":
      case "select": // If you want a dropdown for some questions
      default:
        return (
          <div className={`options-container${!question.singleColumn ? " two-columns" : ""}`}>
            {question.options.map((option) => (
              <button key={option.value} className={`option-button ${selectedOption === option.value ? "selected" : ""}`} onClick={() => handleOptionChange(option.value)}>
                {option.label}
              </button>
            ))}
          </div>
        );
    }
  };

  return (
    <div className="quiz-question">
      <div>
        <h2>{question.text}</h2>
        {renderInput()}
      </div>
      {/* Before & After section */}
      <div className="before-after-section">
        <div className="image-row">
          {/* Use actual image paths here or placeholder SVGs */}
          <img src={`/assets/images/${question.image}`} alt="question_image" loading="lazy"
            decoding="async" />
        </div>
        <p className="testimonial-text" dangerouslySetInnerHTML={{ __html: question.testimonial }}></p>
        {question.author && <p className="testimonial-author">–{question.author}</p>}
      </div>

      {/* Next button at the bottom */}
      <div className="actions">
        {index > 0 && (
          <button onClick={handleBack} className="next-button">
            Back
          </button>
        )}
        <button onClick={handleSubmit} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
}

export default QuizQuestion;
